import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const headerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const ContactUsHeader: React.FC = () => {
  const [ref, inView] = useInView({
    threshold: 0.2,
  });

  return (
    <motion.section
      ref={ref}
      className="relative global-container z-5 text-center flex flex-col items-center mb-[8.55rem]"
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={headerVariants}
      transition={{ duration: 0.8, ease: "easeInOut", staggerChildren: 0.3 }}
    >
      <motion.h1
        className="h3 text-white mb-[1.2rem]"
        variants={headerVariants}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        Contact Us
      </motion.h1>
    </motion.section>
  );
};

export default ContactUsHeader;
